"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_FILTERS = void 0;
exports.DEFAULT_FILTERS = {
    title: undefined,
};
